import { schema, types } from 'papr'

export const optOutHashSchema = schema({
	hash: types.string({ required: true }),
	user: types.objectId(),
	email: types.string(),
	dateAdded: types.date(),
})

export type OptOutHashDocument = (typeof optOutHashSchema)[0]
export type OptOutHashSchemaOptions = (typeof optOutHashSchema)[1]
